module.exports = __webpack_public_path__ + "static/img/eper_quality_fr.840b9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/product-icon/eper_quality_fr.png
// module id = w+jB
// module chunks = 71